import { NumField, NoteField, FormActions } from "./ui";
import { toMilli } from "../../lib/mshopCalc";
import { useOpSave } from "./useOpSave";
import SavedBanner from "./SavedBanner";

const INITIAL = { weight: "", cash: "", bank: "", note: "" };
const LABELS = { sale: "بيع ذهب جديد", purchase: "شراء ذهب مستعمل", expense: "تسجيل مصروف" };

export default function QuickMovementForm({ type }) {
    const { values, set, clear, save, saving, lastSaved, setLastSaved } = useOpSave(type, INITIAL);
    const cash = toMilli(values.cash || "0");
    const bank = toMilli(values.bank || "0");
    const weight = toMilli(values.weight);
    const valid = cash !== null && bank !== null && (cash > 0n || bank > 0n) &&
        (type === "expense" || (weight !== null && weight > 0n));
    return (
        <div data-testid={`mshop-${type}-form`}>
            <div className="mb-4 flex items-end justify-between gap-3">
                <h1 className="font-heading text-3xl font-black text-neutral-900">{LABELS[type]}</h1>
                <span className="text-sm text-neutral-500">{type === "sale" ? "المبالغ تدخل الصندوق" : "المبالغ تخرج من الصندوق"}</span>
            </div>
            {lastSaved ? <SavedBanner op={lastSaved} onClose={() => setLastSaved(null)} /> : null}
            <div className="rounded-[28px] border border-[#E7E5DF] bg-white p-5 shadow-sm sm:p-7">
                <div className="space-y-5">
                    {type !== "expense" && <NumField big label="الوزن" unit="جرام" placeholder="0.00" value={values.weight} onChange={set("weight")} testId={`${type}-weight-input`} />}
                    <NumField big label="الكاش" unit="ر.ع" value={values.cash} onChange={set("cash")} testId={`${type}-cash-input`} />
                    <NumField big label="البنك" unit="ر.ع" value={values.bank} onChange={set("bank")} testId={`${type}-bank-input`} />
                    <NoteField label="البيان" value={values.note} onChange={set("note")} testId={`${type}-note-input`} />
                </div>
                <FormActions onClear={clear} onSave={save} saving={saving} disabled={!valid} saveLabel="حفظ" testPrefix={type} />
            </div>
        </div>
    );
}
